<template>
  <div class="profile-detail">
    <div class="ma-2 text-container">
      <div class="text-h2 centeringText font-weight-medium">
        José Luis Morales Bataz
      </div>
      <br />
      <div class="text-body-1 centeringText">
        Hola, soy José Luis. Soy un desarrollador de software Junior de la
        ciudad de Lázaro Cárdenas, Michoacán.
      </div>
      <br />
      <div class="text-body-1 centeringText">
        Actualmente desarrollo plataformas web, sitios web, aplicaciones móviles
        e híbridas con Node.js, Laravel, Vue.js, me centro principalmente en el
        desarrollo Full-Stack, soy entusiasta del lenguaje JavaScript.
      </div>
      <br />
      <div class="text-body-1 centeringText">
        <!-- Pero definitivamente amo el back-end -->
      </div>
      <div class="text-body-1 centeringText">
        Correo:
        <a href="mailto:moralesbataz.joseluis@gmail.com"
          >moralesbataz.joseluis@gmail.com</a
        >
      </div>
      <!-- <div>
          Iconos diseñados por
          <a href="https://www.freepik.com" title="Freepik">Freepik</a> from
          <a href="https://www.flaticon.es/" title="Flaticon"
            >www.flaticon.es</a
          >
        </div> -->
    </div>
    <v-avatar size="350" class="pt-5 mt-5 ml-5">
      <!-- class="my-12 rounded" -->
      <!-- width="350" -->
      <img
        src="https://firebasestorage.googleapis.com/v0/b/choche-wees.appspot.com/o/perfil%2Fperfil.jpg?alt=media&token=737981fd-8ebb-4c76-aeea-a1de76f766cf"
        alt="Choche Wees"
      />
    </v-avatar>
  </div>
</template>

<script>
export default {
  props: {
    // project: Object
  }
}
</script>

<style lang="scss" scoped>
@import '@/theme/variables.scss';
* {
  color: white;
}

.profile-detail {
  background-image: linear-gradient(rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0.5)),
    url('~@/assets/img/computer-background.jpg');
  background-position: center;
  background-size: 100vw auto;
  object-fit: contain;

  // Tamañp de la sección
  max-width: 100%;
  height: 800px;

  // Flex
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
}

.text-container {
  max-width: 800px;
}

@media (max-width: 1010px) and (min-width: 600px) {
  .centeringText {
    text-align: center;
  }
  // smallscreen
  .profile-detail {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}

@media (max-width: 600px) {
  .centeringText {
    text-align: center;
  }
  // extra smallscreen
  .profile-detail {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}
</style>
